import { type PointerEventHandler } from 'react'
import { type BranchOption, type ResolvedBranchNode } from '@/lib/branchTypes'
import { splitPlanLabel } from '../splitPlanLabel'

type PrimaryButton2ChoicesFiveMobileProps = {
  option: BranchOption
  targetNode: ResolvedBranchNode | null
  inverted: boolean
  showHoverStyleByDefault: boolean
  onClick: () => void
  onPointerEnter?: PointerEventHandler<HTMLElement>
  onPointerLeave?: PointerEventHandler<HTMLElement>
}

// Mobile "Our Recommendation" CTA: taller than secondary plan boxes so the thick border
// extends symmetrically above/below their top/bottom edges (see ChooseYourPathOGMobile).
export const PrimaryButton2ChoicesFiveMobile = ({
  option,
  targetNode,
  inverted,
  showHoverStyleByDefault,
  onClick,
  onPointerEnter,
  onPointerLeave,
}: PrimaryButton2ChoicesFiveMobileProps) => {
  const { prefix, suffix } = splitPlanLabel(option.label)
  const idleBackgroundClass = showHoverStyleByDefault ? 'bg-black/5 hover:bg-black/5' : 'bg-transparent hover:bg-black/5'
  return (
    <div className="flex-1 relative">
      <button
        onClick={onClick}
        onPointerEnter={onPointerEnter}
        onPointerLeave={onPointerLeave}
        className={`rounded-md font-bold tracking-wide transition-colors duration-300 ease-[cubic-bezier(0.16,1,0.3,1)] cursor-pointer border flex flex-col flex-1 items-center w-full justify-center py-[22px] px-6 border-4 text-2xl text-nowrap ${inverted ? 'bg-black text-white border-black' : `border-current ${idleBackgroundClass}`}`}
      >
        {prefix ? (
          <span className="leading-none">
            <span className="block text-[11px] font-normal tracking-wider">{prefix}</span>
            <span className="block text-4xl leading-none">{suffix}</span>
          </span>
        ) : (
          option.label
        )}
        {targetNode?.longSubtitle && <div className={`font-normal tracking-wide text-balance hidden font-serif min-w-[140px] text-wrap text-center mt-2 text-sm ${inverted ? 'text-white/80' : 'text-black/90'}`}>{targetNode.longSubtitle}</div>}
      </button>
      <div className="absolute left-1/2 -translate-x-1/2 top-full mt-3 font-mono text-center font-normal text-[9px] text-gray-500 text-nowrap">(Our Recommendation)</div>
    </div>
  )
}
